import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import {
  BRAND_PURPLE,
  HOVER_BACKGROUND,
  STANDARD_NAV_HEIGHT,
} from "@/css/constants";

export const HEADER_HEIGHT = STANDARD_NAV_HEIGHT;

export const MessageCountContainer = styled(Flex)`
  background-color: ${BRAND_PURPLE};
  color: ${Colors.WHITE};
  text-align: center;
  height: 25px;
  border-radius: 25px;
  padding: 0 10px;
  min-width: 30px;
`;

export const CardContainer = styled(Box)`
  a:focus {
    text-decoration: none;
    outline: none;
  }
  :hover {
    background-color: ${Colors.LIGHT_GRAY5};
  }
  background-color: ${Colors.WHITE};
  &.selected {
    background-color: ${HOVER_BACKGROUND};
    .name {
      font-weight: 600;
    }
  }
`;
